import { Directive, ElementRef, Input, OnChanges, OnInit, Renderer2, SimpleChanges, inject } from '@angular/core';

@Directive({
  selector: '[portalCalcFromFullHeight]',
  standalone: false,
})
export class CalculateFromFullHeightDirective implements OnInit, OnChanges {
  private readonly element = inject(ElementRef);
  private readonly renderer = inject(Renderer2);

  @Input() portalCalcFromFullHeight: number | number[];

  ngOnInit(): void {
    this.changeElementHeight();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.portalCalcFromFullHeight.currentValue) {
      this.changeElementHeight();
    }
  }

  private changeElementHeight(): void {
    this.renderer.setStyle(this.element.nativeElement, 'height', `calc(100% - ${this.calculateCommonHeights()}px`);
  }

  private calculateCommonHeights(): number {
    if (!Array.isArray(this.portalCalcFromFullHeight)) {
      return this.portalCalcFromFullHeight;
    }

    return this.portalCalcFromFullHeight.reduce((prevValue, curValue) => prevValue + curValue, 0);
  }
}
